import { ActAsCandidate, ActAsSession } from "core/types/act-as.types";

// GET /legals/users risponde con lo schema di UserModel.get_all_users_basic
// (name / lastname), lo stesso di transformUserAdmin in code.helpers.ts.
export const transformActAsCandidate = (data: any): ActAsCandidate => ({
  id: data?.id,
  firstName: data?.name ?? "",
  lastName: data?.lastname ?? "",
  email: data?.email ?? "",
  enabled: data?.enabled,
  emailVerified: data?.emailVerified,
});

// La scadenza si ricostruisce da `expires_in` (secondi mancanti, calcolati dal DB con
// TIMESTAMPDIFF: db_queries/act_as_sessions.py:_SELECT_SESSIONE) e NON da `expires_at`.
// `expires_at` arriva come datetime NAIVE, senza fuso: il browser lo legge come ora locale,
// quindi con MySQL su UTC e browser su Europe/Rome una delega da 120 minuti risulterebbe
// gia' scaduta nell'istante in cui si apre — banner mai mostrato e header mai inviato,
// mentre lato server la sessione e' viva. Un delta in secondi non ha questo problema.
const scadenzaLocale = (data: any): string => {
  // null/undefined/"" NON passano da Number(): Number(null) vale 0, e uno 0 preso per buono
  // farebbe scadere la delega nell'istante in cui si apre.
  const grezzo = data?.expires_in;
  const secondi =
    grezzo === null || grezzo === undefined || grezzo === ""
      ? Number.NaN
      : Number(grezzo);
  if (Number.isFinite(secondi)) {
    return new Date(Date.now() + secondi * 1000).toISOString();
  }
  // Backend piu' vecchio che non manda expires_in: si ripiega sulla data, con il rischio
  // di fuso descritto sopra (parseActAsExpiry in core/act-as/act-as.session.ts).
  return data?.expires_at;
};

// La sessione arriva piatta, con i nomi delle colonne di act_as_sessions
// (models/act_as_model.py: open_session / list_open).
export const transformActAsSession = (data: any): ActAsSession => ({
  sessionId: data?.id,
  subject: {
    id: data?.subject_id,
    firstName: data?.subject_first_name ?? "",
    lastName: data?.subject_last_name ?? "",
    email: data?.subject_email ?? "",
  },
  expiresAt: scadenzaLocale(data),
  reason: data?.reason ?? undefined,
});

export const formatActAsSubject = (subject?: {
  firstName?: string;
  lastName?: string;
  email?: string;
}): string => {
  const name = [subject?.firstName, subject?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || subject?.email || "";
};
